import './Aside.css'
import { useTranslation } from 'react-i18next'
import Logo from '../../common/Logo/Logo'
import { AngleLeft, AngleRight, Calender, Home, Payment, Pending, Settings, Users } from '../../../Assets/SVGS'
function Aside({isClose , handleClose}){
  const { t } = useTranslation();
  return (
    <>
      <div className={isClose?'aside-content close content' : "aside-content open content"}>
        <Logo />
        <ul>
          <li>
            <Home width='20px' />
            <a href='/dashboard'>{t('dashboard')}</a>
          </li>
          <li>
            <Users width='20px' />
            <a href='/patients'>{t('patients')}</a>
          </li>
          <li>
            <Calender width='20px' />
            <a href='/confirmed-appointments'>{t('appointments')}</a>
          </li>
          <li>
            <Pending width='20px' />
            <a href='/pending-appointments'>{t('pendingAppointments')}</a>
          </li>
          <li>
            <Payment width='20px' />
            <a href='/payment-review'>{t('paymentReview')}</a>
          </li>
          <li>
            <Home width='20px' />
            <a href='/records'>{t('records')}</a>
          </li>
          <li>
            <Settings width='20px' />
            <a href='/settings'>{t('settings')}</a>
          </li>
          <li>
            <Users width='20px' />
            <a href='/users'>{t('users')}</a>
          </li>
        </ul>
      </div>
        {/* <div className={isClose?'open-close-icon close':'open-close-icon open'} onClick={handleClose}>
          {isClose ? (
            <AngleLeft width='30px' />
          ) : (
            <AngleRight width='30px' />
          )}
        </div> */}
    </>
  );
}
export default Aside